export const openDashboardInNewTab = () => {
  const dashboardUrl = `${window.location.origin}/dashboard`;
  window.open(dashboardUrl, '_blank');
};

export const redirectToDashboard = () => {
  window.location.href = '/dashboard';
}; 